import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    DataTableDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../types";
import {
    getSurfaceStyle
} from "../../helpers/theme/elevation";
import {
    concentric
} from "../../helpers/theme/concentric";
import {
    getCornerStyle
} from "../../helpers/theme/corner";
import {
    webStyle
} from "../../utils";

const stylesheet = StyleSheet.create({
    status: {
        pointerEvents: "none",
        position: "absolute",
        overflow: "hidden",
        ...webStyle({
            clipPath: "inset(50%)",
            whiteSpace: "nowrap"
        })
    },
    container: {
        alignSelf: "stretch",
        minWidth: 0
    },
    clip: {
        overflow: "hidden",
        flexShrink: 1
    }
});

export const useStyles = ({
    shapeConfigs,
    shadowAlpha,
    elevations,
    radiuses,
    borders,
    colors
}: DataTableDynamicStyleType) => {
    const styles = {
        clip: {
            ...getCornerStyle({
                radius: concentric({
                    outer: radiuses.surface,
                    role: radiuses.surface,
                    inset: borders.line
                }),
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        container: {
            ...getSurfaceStyle({
                level: "level1",
                surface: "card",
                shadowAlpha,
                elevations,
                borders,
                colors
            }),
            ...getCornerStyle({
                radius: radiuses.surface,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        status: {
            height: borders.line,
            width: borders.line
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
